/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandDocumentTarget {
    getFixupPrototypeFunction() { return AwsSsmCommandDocumentTarget.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandDocumentTarget>): AwsSsmCommandDocumentTarget {
        let obj = Object.assign(new AwsSsmCommandDocumentTarget(), model);
        AwsSsmCommandDocumentTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandDocumentTarget>): AwsSsmCommandDocumentTarget {
        if (!model) return null;
        return AwsSsmCommandDocumentTarget.newInstance(<AwsSsmCommandDocumentTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandDocumentTarget) {
        if (!obj) return;

        models.AwsSsmCommandDocumentTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandDocumentTarget): boolean {
        Object.setPrototypeOf(obj, AwsSsmCommandDocumentTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Supported keys: InstanceIds/tag/resource-groups
     */
    key: string;

    /**
     * Supported values: <instance-id-1>,<instance-id-2>/<my-tag-value-1>,<my-tag-value-2>/<resource-type-1>,<resource-type-2>
     */
    values: Array<string>;

}
